import {
   SET_IS_PREF_CONFIRM,
   SET_IS_COMM_VALUE
  } from "../../actions/policy/policyActions";

  const initialState = {
    PrefSelection: null,
    Communicationval: null,
  };

  export default function preferenceConfirmReducer(state = initialState, action) {
    switch (action.type) {
      case SET_IS_PREF_CONFIRM:
        return {
          ...state,
          PrefSelection:action.payload
        };
        case SET_IS_COMM_VALUE:
        return {
          ...state,
          Communicationval:action.payload
        };
        default:
          return state;
      }
      
  }